import { Map, List } from 'immutable'
import { combineReducers } from 'redux-immutable'
import { handleActions, combineActions } from 'redux-actions'
import * as actions from './actions'

const IP_ENRICHMENT_LIMIT = 50

const status = handleActions(
  {
    [combineActions(
      actions.fetchDemandbaseCompanyDataPending,
      actions.fetchDemandbaseCompanyDataSuccess,
      actions.fetchDemandbaseCompanyDataFailed,
      actions.fetchDemandbaseCompanyDataCancelled
    )]: (state, action) => {
      return action.type
    },
  },
  Map()
)

const data = handleActions(
  {
    [actions.fetchDemandbaseCompanyDataSuccess]: (state, action) => {
      const { data, ip, endUserId } = action.payload
      if (ip !== undefined) {
        return state.setIn('byIp', ip, data).takeLast(IP_ENRICHMENT_LIMIT)
      } else if (endUserId !== undefined) {
        return state.setIn('byEndUserId', endUserId,  data)
      } else {
        return state
      }
    }
  },
  Map()
)

const industries = handleActions(
  {
    [actions.fetchDemandbaseTargetingIndustriesSuccess]: (state, action) => {
      return action.payload
    }
  },
  List()
)

const subIndustries = handleActions(
  {
    [actions.fetchDemandbaseTargetingSubIndustriesSuccess]: (state, action) => {
      return action.payload
    }
  },
  List()
)


export default combineReducers({ status, data, industries, subIndustries })



// WEBPACK FOOTER //
// ./src/scripts/app/modules/enrichment/demandbase/reducer.js